<template>
  <div>
    <v-text-field
      v-model="dep_date"
      label="Departure Date"
      hint="YYYY-MM-DD format"
      :rules="depDateRules"
      :clearable="false"
      :show-current="false"
      @focus="calDep = true"
      :append-icon="calDep ? 'close' : ''"
      @click:append="hideCalDep"
      mask="####-##-##"
      :return-masked-value="true"
      outline
    ></v-text-field>
    <v-date-picker
      ref="dep_date_picker"
      v-show="calDep === true"
      v-model="dep_date"
      type="date"
      full-width
      :landscape="false"
      format="yyyy-MM-dd"
      :allowedDates="enabledDates"
      max-width="250px"
      @input="handleInput()"
      :reactive="true"
    >
    </v-date-picker>
  </div>
</template>

<script>
import Shared from "@/mixins/Shared";

export default {
  name: "SelectDepartDate",
  mixins: [Shared],
  data: () => ({
    hideDepCalBtn: true,
    calDep: false,
  }),
  methods: {
    handleInput() {
      this.dpInputDep();
      this.calDep = false;
    }
  }
}
</script>
